import React from 'react'
import { PaginationItem as MuiPaginationItem } from '@mui/lab'
import makeStyles from '@mui/styles/makeStyles';

const sizes = {
    small: '26px',
    medium: '32px',
    large: '40px',
}

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: '0px',
        margin: '0px !important',
        border: 'solid 1px #ebebed',
        color: '#5d6870',
        borderRight: 'none',
        fontSize: '14px !important',
        '&:hover': {
            backgroundColor: '#ffffff',
            color: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },

    ellipsis: (props) => ({
        height: props.size ? sizes[props.size] : '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRight: '0px',
    }),
    selected: {
        backgroundColor: `${theme.palette.primary.main} !important`,
        border: 'none',
        color: '#ffffff',
        '&:hover': {
            color: '#ffffff',
        },
    },
}))

const PaginationItem = ({ size, ...rest }) => {
    const classes = useStyles({ size })
    return <MuiPaginationItem classes={classes} size={size} {...rest} />
}

export default PaginationItem
